import { http } from '../../config/axios'

 const findRegistro = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/registro/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findRegistro', error)
      throw Error(error.response.data)
    })
}

export default findRegistro;
